type IndexType = {
  [index: string]: number;
};

// 메뉴 타이틀 글자 수 제한
export const MenuTitleWordLimit: IndexType = {
  ko: 7,
  en: 11,
  ja: 7,
  cn: 7,
  tw: 7,
};

// 테넌트 타이틀 글자 수 제한
export const TenantTitleWordLimit: IndexType = {
  ko: 30,
  en: 50,
  ja: 30,
  cn: 30,
  tw: 30,
};

// 커스텀 필드 타이틀 글자 수 제한
export const CustomFieldTitleWordLimit: IndexType = {
  ko: 7,
  en: 11,
  ja: 7,
  cn: 7,
  tw: 7,
};

// 커스텀 메뉴 콘텐츠 타이틀 글자 수 제한
export const CustomContentTitleWordLimit: IndexType = {
  ko: 40,
  en: 58,
  ja: 40,
  cn: 40,
  tw: 40,
};
